<template>
  <v-footer
    class="
      footer
      body-2
      pt-md-10
      sn-caption sn-text-primary-01
      d-flex
      align-start
    "
  >
    <v-container>
      <v-row class="app-store-icons mb-5 d-flex justify-center">
        <img
          v-if="userAgent === 'Android' || userAgent === 'unknown'"
          alt="Click to install app from Google Play store"
          :src="googlePlay"
          class="hoverable"
          @click="goToInstallLink()"
        >
        <img
          v-if="userAgent === 'iOS' || userAgent === 'unknown'"
          alt="Click to install app from Apple app store"
          :src="appleStore"
          class="hoverable"
          @click="goToInstallLink()"
        >
      </v-row>
      <v-row class="mb-5 d-flex justify-center">
        <template v-for="(logo, index) in logos">
          <img
            :key="index"
            :src="`${logo.iconUrl}`"
            :alt="`${logo.iconName} logo`"
            width="40"
            height="40"
            class="mx-3 my-1"
          >
        </template>
      </v-row>

      <v-row class="mb-5 d-flex justify-center">
        <a
          :href="`mailto:${supportEmail}`"
          class="support-text sn-h4 sn-text-primary-01"
        >
          Support
        </a>
      </v-row>

      <v-row class="mb-5 d-flex justify-center">
        <span>
          Questions? Contact {{ servicerFullName }} | Mortgage Loan Officer
          <a
            :href="`mailto:${servicerEmail}`"
            class="link-text no-underline"
          >
            | {{ servicerEmail }}
          </a>
          <span v-if="cellPhone"> | Cell: {{ cellPhone }} </span>
          <span v-if="workPhone"> | Work: {{ workPhone }} </span>
        </span>
      </v-row>

      <v-row class="mb-5 d-flex justify-center">
        <span>
          {{ companyName }}
          {{ companyNMLS }} |
          {{ servicerFullName }}
          {{ servicerNMLS }}
        </span>
      </v-row>

      <v-row
        v-if="stateLicenses"
        class="mb-5 d-flex justify-center"
      >
        <span> Licenses: {{ stateLicenses }} </span>
      </v-row>

      <v-row
        v-if="disclaimer"
        class="mb-5 d-flex justify-center"
      >
        <span>
          {{ disclaimer }}
        </span>
      </v-row>

      <v-row
        v-if="termsOfUse || privacyPolicy"
        class="d-flex justify-center last-row"
      >
        <span>
          <a
            v-if="termsOfUse"
            :href="termsOfUse"
            class="link-text"
            target="_blank"
          >
            Terms of Use
          </a>
          <span v-if="termsOfUse && privacyPolicy"> &nbsp;|&nbsp; </span>
          <a
            v-if="privacyPolicy"
            :href="privacyPolicy"
            class="link-text"
            target="_blank"
          >
            Privacy Policy
          </a>
        </span>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { NullServicer } from '../Servicer/nullProfile'
import { formatNMLS } from '../../Shared/formatNMLS.js'
import googlePlay from '~/assets/images/google_play_sm-eng.png'
import appleStore from '~/assets/images/app_store_sm-eng.png'

export default {
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => {
        return new NullServicer()
      }
    },
    sac: {
      type: String,
      required: true,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      companyDefaultCode: '',
      showChooseLo: false,
      store: this.$store,
      chooseLoTitleText: '',
      googlePlay: googlePlay,
      appleStore: appleStore
    }
  },
  computed: {
    servicerNMLS () {
      return formatNMLS(this.servicer?.license)
    },
    companyName () {
      return this.servicer?.effective_company_name
    },
    companyNMLS () {
      return formatNMLS(this.servicer?.effective_company_nmls)
    },
    servicerFullName () {
      return this.servicer?.full_name
    },
    servicerEmail () {
      return this.servicer?.email || this.$route.params.code
    },
    supportEmail () {
      return this.servicer?.effective_support_email
    },
    logos () {
      return this.servicer?.effectiveEhLogos
    },
    cellPhone () {
      const phone = this.servicer?.unformatted_phone
      return phone && phone.length === 10
        ? phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
        : undefined
    },
    workPhone () {
      return this.servicer?.office_phone || undefined
    },
    privacyPolicy () {
      return this.servicer?.effective_privacy_policy_link || undefined
    },
    termsOfUse () {
      return this.servicer?.effective_terms_of_use_link || undefined
    },
    stateLicenses () {
      const raw = this.servicer?.state_lics
      const parsed = raw ? JSON.parse(this.servicer?.state_lics) : undefined
      return parsed && parsed.length > 0
        ? parsed.map((el) => `${el.state}: ${el.value}`).join(' | ')
        : undefined
    },
    disclaimer () {
      return this.servicer?.effective_website_disclaimer
    },
    userAgent: function () {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera

      if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone'
      } else if (/android/i.test(userAgent)) {
        return 'Android'
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS'
      }

      return 'unknown'
    }
  },
  methods: {
    goToInstallLink () {
      window.location.replace('/install/app/' + this.sac)
    },
    formatNMLS
  }
}
</script>

<style scoped lang="scss">
@import "~/assets/css/snui";

.footer {
  background-color: $sn-white;
}
.app-store-icons img {
  margin-left: 8px;
  margin-right: 8px;
}
.last-row {
  margin-bottom: -10px;
}
.link-text {
  color: $sn-primary-01;
}
.no-underline {
  text-decoration: none;
}
.hoverable {
  cursor: pointer;
}

@media screen and (max-width: $medium-screen-size) {
  .footer {
    background-color: initial;
  }
}

@media screen and (min-width: 1904px) {
  .footer {
    height: 100%;
  }
}
</style>
